import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import {
  ProStudioEvents,
  ProStudioContext,
  SelectedSolution,
  Solution,
} from '../prostudio.xstate.types';
import { checkForErrors } from '../../utils';

export const updateSolutionName = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  selectedSolution: SelectedSolution | undefined;
  solutions?: Solution[];
  cb?: (path?: string) => void;
} | void> => {
  if (event.type !== 'updateSolutionName') {
    return;
  }

  const { solutions } = ctx;

  const { solutionId, name } = event;

  const updateSolutionNameResponse = await urqlGql.updateSolutionDisplayName({
    displayName: name,
    solutionId,
  });

  checkForErrors(updateSolutionNameResponse);

  const updatedSolutionNameData =
    updateSolutionNameResponse.data?.admin_?.updateSolution;

  // Match on the stable `id` — but only when it is actually present. `id` is
  // typed `string | null`, and an unpublished solution can carry a null id, so
  // a null response id must NOT collide with the first null-id row (the same
  // class of bug the previous `botSolutionId` match had).
  const updatedId = updatedSolutionNameData?.id;

  const selectedSolution =
    updatedId != null
      ? solutions?.find((solution) => solution.id === updatedId)
      : undefined;

  const updatedSelectedSolution = selectedSolution
    ? {
        ...selectedSolution,
        displayName: updatedSolutionNameData?.displayName,
      }
    : undefined;

  const updatedSolutions = solutions?.map((solution) =>
    updatedSelectedSolution && solution.id === updatedSelectedSolution.id
      ? updatedSelectedSolution
      : solution
  );

  return {
    selectedSolution: updatedSelectedSolution,
    solutions: updatedSolutions
      ? updatedSolutions.filter(
          (solution): solution is Solution => solution !== undefined
        )
      : undefined,
  };
};
